/* eslint-disable react/display-name */
import { Button, IconButton, Tooltip, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";

import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FxRateCrud from "./FxRateCrud";

export default function FxRateList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  function addFxRate() {
    biRef.child.showFxRateWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showFxRateWindow(row.tableData[row.rowIndex].id);
  }

  async function loadData() {
    loaadByDB();
  }
  async function loaadByDB() {
    db.fxrate.toArray(function (data) {
      setData(data);
    });
  }

  function formatDate(date) {
    let formatted =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    return formatted;
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    search: false,
    filter: false,
    pagination: false,
    viewColumns: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    print: false,

    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={fxRateListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={translate("Add FX Rate")}>
            <IconButton size="small" color="secondary" onClick={addFxRate}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const columns = [
    {
      name: "sourceCurrencyCode",
      label: translate("Source Currency"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "baseCurrencyCode",
      label: translate("Base Currency"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "conversionRate",
      label: translate("Conversion Rate"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "effectiveDate",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return formatDate(new Date(value));
        },
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "right",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            Edit
          </Button>
        ),
      },
    },
  ];

  function fxRateListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid container style={{ marginTop: "15px" }}>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={translate("FX Rate List")}
            data={data}
            columns={columns}
            options={options}
          />
        </div>
      </Grid>
      <FxRateCrud
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={fxRateListRefresh}
      ></FxRateCrud>
    </Grid>
  );
}
